import { getActiveTraceHttpRequestHeaders } from '@atlaskit/react-ufo/experience-trace-id-context';
import { logError } from '@databases/logs';

import {
  type ContentSearchAllowedScopes,
  type ContentSearchResult,
  type SearchContent,
} from '../types';

const RequestURI = '/gateway/api/xpsearch-aggregator/quicksearch/v1';

export const searchContent = async (
  query: string,
  cloudId: string,
  limit = 20,
  scopes: ContentSearchAllowedScopes[] = ['page'],
  filters: any[] = [],
  searchSession = { sessionId: 'not-applicable', referrerId: null },
  experience = 'databases-content-picker',
  cloudIds: string[] = []
) => {
  const body = {
    query,
    cloudId,
    limit,
    scopes: [`confluence.${scopes.join(',')}`],
    filters,
    searchSession,
    experience,
    cloudIds,
  };

  const response = await fetch(RequestURI, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      ...(getActiveTraceHttpRequestHeaders() ?? {}),
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    logError(new Error(`Response status: ${response.status}`));
  }

  const data = (await response.json()) as ContentSearchResult;

  return data.scopes.reduce((acc: SearchContent[], scope) => {
    acc.push(...scope.results);
    return acc.flat();
  }, []);
};
